<div
  class="hrsuite-page-container"
  [ngClass]="{ 'dark-mode': isDarkMode, dark: !isDarkMode && isNight, 'scenario-page': isScenarioPage }"
>
  @if (!isScenarioPage) {
    <div class="page-title">
      <p class="title" [ngClass]="{ 'white-text': isDarkMode }">
        {{ headerMode }}
        <span [ngClass]="{ 'white-text': isDarkMode }" *ngIf="accessOptions?.multipleHeader">
          /
          <app-dropdown-menu
            [options]="
              isCampaignPage
                ? headerPagesCampaign
                : isListPage
                  ? headerPagesList
                  : isDemandePage
                    ? headerPagesDemande
                    : headerPages
            "
            [placeholder]="
              isCampaignPage
                ? actifPageCampaign
                : isListPage
                  ? actifPageList
                  : isDemandePage
                    ? actifPageDemande
                    : actifPage
            "
            (selectionChange)="navigateToPage($event)"
          >
          </app-dropdown-menu>
        </span>
        <span *ngIf="!accessOptions?.multipleHeader && accessOptions?.headerTitle">{{
          accessOptions?.headerTitle ?? ''
        }}</span>
      </p>

      <div
        *ngIf="
          accessOptions?.pageUrl?.includes('hrsuite/liste') ||
          accessOptions?.pageUrl?.includes('hrsuite/simpledayneeds')
        "
        fxLayout="row"
      >
        @if (
          (accessOptions?.pageUrl?.includes('hrsuite/simpledayneeds') ||
            accessOptions?.pageUrl?.includes('hrsuite/liste')) &&
          accessOptions?.permissionWrite &&
          accessOptions?.adjustPlanning &&
          isBasicService
        ) {
          <app-button
            class="margin"
            (click)="triggeradjustPlanning()"
            [text]="'Ajuster le planning'"
            [icon]="'tune'"
            iconType="mat-icon"
            iconPosition="left-icon"
            btnType="outlined"
          ></app-button>
        }

        <app-button
          *ngIf="
            accessOptions?.pageUrl?.includes('hrsuite/liste') &&
            accessOptions?.permissionWrite &&
            accessOptions?.displayProfileCreation &&
            !isMultiHospitals
          "
          class="margin"
          (click)="openExportDialog()"
          btnType="outlined"
          text="Exporter"
          [icon]="'file_download'"
          iconType="mat-icon"
          iconPosition="left-icon"
        ></app-button>

        <app-button
          *ngIf="accessOptions?.permissionWrite && accessOptions?.displayProfileCreation"
          [ngClass]="{ margin: !isSurgeonPage }"
          (click)="addProfileClick()"
          text="Créer un profil"
          [icon]="'person_add'"
          iconType="mat-icon"
          iconPosition="left-icon"
          btnType="outlined"
        ></app-button>
        <app-button
          *ngIf="
            accessOptions?.pageUrl?.includes('hrsuite/liste') &&
            accessOptions?.permissionWrite &&
            accessOptions?.displayOpenVacations
          "
          class="margin"
          (click)="openVacationPopup()"
          [text]="
            'Ouvrir ' +
            (hospitalNames.vacationsNameGenreMasculin ? 'un ' : 'une ') +
            hospitalNames.vacationsName.toLowerCase()
          "
          [icon]="'event_available'"
          iconType="mat-icon"
          iconPosition="left-icon"
          btnType="outlined"
        ></app-button>
        <app-button
          *ngIf="
            accessOptions?.pageUrl?.includes('hrsuite/liste') &&
            accessOptions?.permissionWrite &&
            accessOptions?.displayRelance
          "
          class="margin"
          (click)="openPopupRelaunchAvai()"
          [icon]="'schedule_send'"
          matTooltip="Relance de disponibilités"
          text="Relancer"
          iconType="mat-icon"
          iconPosition="left-icon"
          btnType="outlined"
        ></app-button>
        <app-button
          *ngIf="
            accessOptions?.pageUrl?.includes('hrsuite/liste') &&
            accessOptions?.permissionWrite &&
            accessOptions?.displayUpdateData &&
            canDataBeRequestByUsers
          "
          class="margin"
          (click)="triggerRequestCalendarsFromHospital()"
          btnType="primary"
          [text]="importButtonName"
          [icon]="'download'"
          iconType="mat-icon"
          iconPosition="left-icon"
        ></app-button>
      </div>

      @if (accessOptions?.pageUrl?.includes('hrsuite/stats-rh')) {
        <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="12px">
          @if (strategic) {
            <div class="config">
              <app-button
                (click)="openConfigDropdown(); $event.stopPropagation()"
                [text]="'Configurer'"
                iconPosition="left-icon"
                iconType="mat-icon"
                icon="tune"
                btnType="text"
                [hoverBackground]="false"
                [disabled]="(statsRHLoading$ | async) || false"
              ></app-button>

              @if (configDropdownOpen) {
                <div class="config-drop-down">
                  <div class="item" (click)="$event.stopPropagation()">
                    <input
                      (change)="modifyUserStatsRHConfig('displayInHourVolume')"
                      [checked]="displayInHourVolume"
                      type="checkbox"
                    />
                    <label (click)="modifyUserStatsRHConfig('displayInHourVolume')" class="label"
                      >Afficher en volume horaire <span>(sinon ETP)</span></label
                    >
                  </div>

                  <div class="item" (click)="$event.stopPropagation()">
                    <input
                      (change)="modifyUserStatsRHConfig('considerBreaktimes')"
                      [checked]="considerBreaktimes"
                      type="checkbox"
                    />
                    <label (click)="modifyUserStatsRHConfig('considerBreaktimes')" class="label"
                      >Prendre en compte les temps de pause</label
                    >
                  </div>

                  <div class="item" (click)="$event.stopPropagation()">
                    <input
                      (change)="modifyUserStatsRHConfig('includeWeekends')"
                      [checked]="includeWeekends"
                      type="checkbox"
                    />
                    <label (click)="modifyUserStatsRHConfig('includeWeekends')" class="label"
                      >Inclure les week-ends</label
                    >
                  </div>
                </div>
              }
            </div>
          }

          <app-button
            class="margin"
            (click)="openPopulationDetailPopup()"
            [text]="'Détails du périmètre'"
            iconPosition="left-icon"
            btnType="outlined"
            [disabled]="isLoadingPopulation || !currentPopulation.value || !allRooms || !allFormations"
          ></app-button>

          @if (
            (allFormationsGroups && allFormationsGroups.length > 0) || (populationList && populationList.length > 0)
          ) {
            <div
              class="w-200 custom-select"
              [class.disabled]="(statsRHLoading$ | async) || false"
              (click)="togglePopulationDropdown(); $event.stopPropagation()"
            >
              <p class="custom-trigger">{{ !selectionName ? 'Aucun périmètre' : selectionName }}</p>
              <div class="icon" (click)="togglePopulationDropdown(); $event.stopPropagation()">
                <span class="material-symbols-outlined">
                  {{ isPopulationDropdownOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
                </span>
              </div>

              @if (isPopulationDropdownOpen) {
                <div class="selection-dropdown">
                  @if (allFormationsGroups && allFormationsGroups.length > 0) {
                    <div class="dropdown-group">
                      @for (group of allFormationsGroups; track group._id) {
                        <div
                          class="dropdown-item"
                          (click)="
                            onPopulationSelected(group, true);
                            isPopulationDropdownOpen = false;
                            $event.stopPropagation()
                          "
                        >
                          {{ group.displayName || group.name }}
                        </div>
                      }
                    </div>
                    <div class="divider"></div>
                  }

                  <!-- Groupe Périmètres personnalisés -->
                  @if (!isMultiHospitals && populationList && populationList.length > 0) {
                    <div class="dropdown-group">
                      <div class="group-label">Mes périmètres personnalisés</div>
                      @for (population of populationList; track population._id) {
                        <div
                          class="dropdown-item"
                          (click)="
                            onPopulationSelected(population); isPopulationDropdownOpen = false; $event.stopPropagation()
                          "
                        >
                          {{ population.name }}
                        </div>
                      }
                    </div>
                  }
                </div>
              }
            </div>
          }

          <app-range-date-picker
            [showArrows]="false"
            (SelectedDates)="onStatsRhDateChange($event)"
            [sideOpening]="'left'"
            [hasDefaultRanges]="true"
            [hasPastRanges]="true"
            [maxDate]="today"
            [fusionnedInput]="true"
            [startDay]="startDay"
            [endDay]="endDay"
            [isDisablePicker]="(statsRHLoading$ | async) || false"
          ></app-range-date-picker>

          @if (strategic) {
            <app-button
              class="margin"
              (click)="loadData()"
              [text]="'Charger les données'"
              iconPosition="left-icon"
              btnType="primary"
              [disabled]="!hasChanges"
            ></app-button>
          }

          <app-toggle-switch
            [options]="options"
            [isMensuel]="true"
            [equalColumnsWidth]="true"
            [actifOption]="strategic"
            (onOptionClick)="changeRHStatsMode()"
            [light]="true"
            [disabled]="(statsRHLoading$ | async) || false"
          ></app-toggle-switch>
        </div>
      }
    </div>
  }

  <app-buttons-floating-component
    *ngIf="isAnesthNeedsPage && accessOptions?.permissionWrite && isChangeAnesthNeeds"
    [disabled]="isSavingAnesthNeeds"
    (onClick)="onClickHandlerAnesth($event)"
  >
  </app-buttons-floating-component>

  <router-outlet></router-outlet>
</div>
